import React from 'react';
import LandingScreen from './LandingScreen';
import LoadingSpinner from './LoadingSpinner';
import { useAuth } from 'react-oidc-context';
// import { Button, Box, Typography, Container } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { Card, Button } from "@nextui-org/react";
import { FiCheckCircle, FiXCircle } from 'react-icons/fi';


function App(APP_ID) {
  const auth = useAuth();
 
  switch (auth.activeNavigator) {
      case "signinSilent":
          return <div>Signing you in...</div>;
      case "signoutRedirect":
          return <div>Signing you out...</div>;
  }

  // if (auth.isLoading) {
  //   return (
  //    {LoadingSpinner}

     
  //   );
  // }

  if (auth.error) {
    return <div>Encountering error... {auth.error.message}</div>;
  }

  if (auth.isAuthenticated) {
    return (
      <div>
        {/* <button onClick={() => auth.removeUser()}>Sign out</button>
        <LandingScreen /> */}
        <LandingScreen APP_ID={APP_ID} auth={auth} />
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-b from-white to-[#f4f4f4] text-center p-6">
    <div className="w-full max-w-4xl px-6">
      <h1 className="text-5xl sm:text-6xl font-extrabold leading-tight text-black mb-4">
       Grubify
      </h1>
      <p className="text-lg sm:text-xl text-gray-600 mb-8">
      Streamline your order process and enhance your business efficiency with Grubify.
      </p>
      <div className="flex flex-col sm:flex-row justify-center items-center gap-4">
   
        <Button
          className="bg-white text-black border border-black text-lg px-6 py-3 rounded-lg hover:bg-gray-100"
          onPress={() => auth.signinRedirect()}
        >
          Log in
        </Button>
      </div>
    </div>
  </div>



  );
  

}

export default App;
